import React from 'react';
import { Trans } from 'react-i18next';
import { getBaseUrl } from '../../../common/common';
import { useCartData } from '../../../hooks/order';

// The single-page checkout's terms checkbox copy (singlePageCheckout.termsAndConditionsCheck)
// with Terms / Acceptable Use Policy / Privacy Policy linked to the same URLs the legacy Terms &
// Conditions step uses (CheckOut.js's TermsAndConditions). stopPropagation keeps a link click
// from also toggling the checkbox it sits in.
const TermsAgreementText = () => {
  const { spanishLanguagePref } = useCartData();

  const acceptableUsePolicyUrl = spanishLanguagePref
    ? `${getBaseUrl()}tcs/acceptable-use-policy-es/`
    : `${getBaseUrl()}tcs/acceptable-use-policy/`;
  const privacyPolicyUrl = spanishLanguagePref
    ? `${getBaseUrl()}tcs/privacy-policy-spanish/`
    : `${getBaseUrl()}tcs/privacy-policy/`;

  const link = (href) => (
    // Trans fills in the link text from the translation string.
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="spc-terms-agreement-link"
      onClick={(e) => e.stopPropagation()}
    />
  );

  return (
    <Trans
      i18nKey="singlePageCheckout.termsAndConditionsCheck"
      components={{
        terms: link(`${getBaseUrl()}tcs`),
        aup: link(acceptableUsePolicyUrl),
        privacy: link(privacyPolicyUrl),
      }}
    />
  );
};

export default TermsAgreementText;
